import axios from 'axios';
import { API_BASE_URL } from '../utils/utils';
import i18n from '../i18n';

const BASE_URL = API_BASE_URL;

const transformTranslatableFields = (data, customFields = ['name', 'title', 'description']) => {
    if (!data || typeof data !== 'object') return data;
    const translatableFields = customFields;
    const currentLang = i18n.language || 'en';

    // Handle arrays
    if (Array.isArray(data)) {
        return data.map(item => transformTranslatableFields(item, translatableFields));
    }

    // Handle objects
    const transformed = { ...data };

    // Transform direct translatable fields
    translatableFields.forEach(field => {
        if (transformed[field] && typeof transformed[field] === 'object' && !Array.isArray(transformed[field])) {
            if (transformed[field].en || transformed[field].fr) {
                const translated = transformed[field][currentLang] || transformed[field]['en'] || '';
                transformed[field] = translated;
            }
        }
    });

    // Recursively transform nested objects and arrays
    Object.keys(transformed).forEach(key => {
        if (transformed[key] && typeof transformed[key] === 'object') {
            transformed[key] = transformTranslatableFields(transformed[key], translatableFields);
        }
    });

    return transformed;
};

export default axios.create({
  baseURL: BASE_URL,
});

export { transformTranslatableFields };